import { useStriveSocketListener } from 'hooks/use-strive-socket-listener/use-strive-socket-listener';
import { useIdleTicker } from 'hooks/use-idle-ticker';

export const Trackers = () => {
  // useStriveSocketListener();
  // useIdleTicker();

  return <></>;
};
